import { fetchWrapper, handleResponse, hcUrl, buildOpts } from 'services/RequestService/helpers';

export const getPauseOfferRewards = async () => {
  const response = await fetchWrapper(hcUrl('/pauses/offer_rewards'), buildOpts());
  return handleResponse(response);
};
